import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pin-off",
  "use": "icon-pin-off-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-pin-off\">\n  <line x1=\"2\" y1=\"2\" x2=\"22\" y2=\"22\" />\n  <path d=\"M12 17v5\" />\n  <path d=\"M9 9.76a2 2 0 0 1-1.06 1.76l-2.44 1.22V17h13v-3.26l-2.44-1.22A2 2 0 0 1 15 9.76V5.74L17 3.8V2H7v1.8l2 1.94z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol